import request from '@/utils/request'
const dataObj = {
	version: '1.0',
	nonceStr: '1212fsadf',
	timestamp: '2020-4-21',
	signType: 'md5',
	content: {},
	sign: 'dafdsf'
}

// 查询时间段
export function getstalls (data) {
	return request({
		url: '/api/v2/alloc/mealtime/list-by-param',
		method: 'post',
		data: { ...dataObj, content: data || {} }
	})
}

// 查询营业时间
export function getbusinessdate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mtime/getMerTime',
		method: 'get',
		params: obj
	})
}

// 新增营业时间
export function insertbusinessdate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mtime/saveTime',
		method: 'post',
		data: obj
	})
}

// 更新营业时间
export function putOpenTOInter (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mtime/putOpenTOInter',
		method: 'put',
		data: obj
	})
}

// 删除营业时间
export function deletebusinessdate (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/mtime/deleteMerTime',
		method: 'delete',
		data: obj
	})
}

// 食堂档口设备树
export function getMacTree (data) {
	const obj = JSON.parse(JSON.stringify(dataObj))
	if (data) {
		obj.content = data
	}
	return request({
		url: '/api/v1/mkttimequota/mac/tree',
		method: 'get',
		params: obj
	})
}
